const PRIVILEGE_ADMIN = 'P_A_ROLE';
const PRIVILEGE_USER = 'P_USER';
const P_WGYC_ANYDAY = 'P_WGYC_ANYDAY';
const T_SXWY_ZS = 'T_SXWY_ZS';
const P_LZCJ_TODAY = 'P_LZCJ_TODAY'
const P_XXXW = 'P_XXXW'

export {
    PRIVILEGE_ADMIN,
    PRIVILEGE_USER, P_LZCJ_TODAY, P_WGYC_ANYDAY, P_XXXW, T_SXWY_ZS
};

